<template>
  <div class="container min-vh-100">
    <div class="row min-vh-100">
      <div class="col-md-4 m-auto">
        <section class="row">
          <div class="col-12">
            <img
              src="/img/logo.jpg"
              class="img-logo img-responsive mb-3"
              alt="logo"
            />
            <h5 class="text-center text-muted login">CBA Sucre</h5>
          </div>
        </section>
        <section class="row" v-if="loaderUser">
          <div class="col">
            <div class="alert alert-success" role="alert">
              <strong>Cargando datos...</strong>
            </div>
          </div>
        </section>
        <section class="row" v-if="existUser">
          <div class="col">
            <p>Por favor introduzca una nueva contraseña</p>
            <div class="alert alert-danger" role="alert" v-if="response.error">
              <strong>{{ response.message }}</strong>
            </div>
            <div
              class="alert alert-success"
              role="alert"
              v-if="response.success"
            >
              <strong>{{ response.message }}</strong>
            </div>
          </div>
        </section>
        <section class="row" v-else>
          <div class="col">
            <div class="alert alert-danger" role="alert">
              <strong>La recuperacion de contraseña ha caducado.</strong>
            </div>
            <router-link to="/ingresar" custom v-slot="{ href, navigate }">
              <a
                :href="href"
                class="btn btn-primary btn-block"
                @click="navigate"
              >
                Volver al inicio
              </a>
            </router-link>
          </div>
        </section>
        <section class="row" v-if="existUser">
          <div class="col">
            <ValidationObserver ref="form" v-slot="{ invalid }">
              <form @submit.prevent="resetPassword">
                <section class="row">
                  <div class="col-12">
                    <div class="form-group required">
                      <ValidationProvider
                        name="password_new"
                        rules="required|min:6|max:60"
                        vid="password_new"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="password_new"
                          >Nueva contraseña</label
                        >
                        <input
                          type="password"
                          v-model="user.password_new"
                          class="form-control form-control-sm"
                          id="password_new"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>
                <section class="row">
                  <div class="col-12">
                    <div class="form-group required">
                      <ValidationProvider
                        name="password_confirm"
                        rules="required|min:6|max:60|password:@password_new"
                        v-slot="{ valid, errors }"
                      >
                        <label class="control-label" for="password_confirm"
                          >Confirmar contraseña</label
                        >
                        <input
                          type="password"
                          class="form-control form-control-sm"
                          id="confirm"
                          v-model="user.password_confirm"
                        />
                        <b-form-invalid-feedback :state="valid">{{
                          errors[0]
                        }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>
                </section>
                <div class="form-group row">
                  <div class="col-12">
                    <button
                      type="submit"
                      class="btn btn-block btn-primary"
                      variant="success"
                      :disabled="invalid || addLoader"
                    >
                      <span v-if="!addLoader">Restablecer su contraseña</span>
                      <span v-if="addLoader">
                        Cargando
                        <CSpinner color="success" size="sm" />
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormInvalidFeedback } from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, confirmed, max, min } from "vee-validate/dist/rules";
import Auth from "@/plugins/services/auth";
import Users from "@/plugins/services/users";
import Mail from "@/plugins/services/mail";

export default {
  name: "ChangePassword",
  components: { BFormInvalidFeedback },
  data() {
    return {
      user: {
        email: "",
      },
      response: {
        error: false,
        success: false,
        message: "",
      },
      addLoader: false,
      loginLoader: false,
      loaderUser: true,
      existUser: false,
    };
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido.",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });

    extend("min", {
      ...min,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como mínimo.",
    });

    extend("password", {
      params: ["target"],
      validate(value, { target }) {
        return value === target;
      },
      message: "Las contraseñas no coinciden.",
    });

    extend("currentPassword", {
      validate: this.isCurrentPassword,
      message: "La contraseña que ingresaste es incorrecta.'",
    });
  },
  mounted() {
    const { hash } = this.$route.params;
    Users.getOneByHash(hash)
      .then((res) => {
        this.loaderUser = false;
        this.user = res.data;
        if (this.user) this.existUser = true;
      })
      .catch((err) => {
        this.loaderUser = true;
        console.log(err);
      });
  },
  methods: {
    resetPassword() {
      this.addLoader = true;
      this.response = {
        error: false,
        success: false,
        message: "",
      };
      let password_new = this.user.password_new;
      Auth.csrf(this.user)
        .then((res) => {
          Users.changePasswordRecover(this.user.id, this.user)
            .then((res) => {
              this.addLoader = false;
              this.response.success = true;
              this.response.message = res.data.message;
              this.login({
                username: this.user.username,
                password: password_new,
              });
            })
            .catch((err) => {
              console.log(err);
              this.addLoader = false;
              this.response.error = true;
              if (err.response && err.response.status == 422) {
                this.response.message = err.response.data.message;
              }
              if (err.response && err.response.status == 500) {
                this.response.message = err.response.data.message;
              }
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    login(user) {
      this.loginLoader = true;
      this.messageError = "";
      Auth.csrf(user)
        .then((res) => {
          Auth.login(user)
            .then((res) => {
              this.messageError = "";
              this.addLoader = false;
              let user = res.data;
              this.$store.commit("set", ["userAuth", user]);
              this.$router.replace("/dashboard");
            })
            .catch((err) => {
              this.addLoader = false;
              if (err.response && err.response.status == 422) {
                this.messageError = err.response.data.errors.email[0];
              }
              if (err.response && err.response.status == 500) {
                this.messageError = "Error 500.";
              }
              this.$store.commit("set", ["userAuth", null]);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async isCurrentPassword() {
      return Users.currentPassword(this.user)
        .then((res) => {
          if (res.data.data == true) {
            return false;
          } else {
            return true;
          }
        })
        .catch((err) => {
          return true;
        });
    },
  },
};
</script>
